import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { Modal } from "../../../../theme/Component/Modal";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _FactoryDocument } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { SelectProccessTypeConstants } from "./SelectProccessTypeConstants";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../../theme/Input/InputDate";
import { BasicButton } from "../../../../theme/Component/BasicButton";



export const FactoryDocument = () => {

    const FactoryDocument = useDataBean(_FactoryDocument);
    const single = Singleton.getInstance();
    const [processType, setprocessType] = useState<number>(null)
    const [lista, setLista] = useState<any>([]);
    const [appoGroup, setAppoGroup] = useState<number>(null)
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [])

    const getLista = () => {

        FactoryDocument.instance.getDocumentFactoryCatalog(processType).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                }
            }
        )

    }

    const create = () => {
        FactoryDocument.setBean({

        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        FactoryDocument.deleteItemVoid(FactoryDocument.bean.IDEntailment).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(entailment.bean);
        FactoryDocument.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDDocumentFactory', visible: true },
        { title: 'Mnemonic', property: 'Mnemonic', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Clase Fábrica', property: 'DocumentFactory', visible: true },
        { title: 'Clase Visor', property: 'ViewerFactoryClass', visible: true },
        { title: 'Tipo de Proceso', property: 'ProcessTypeName', visible: true },
        { title: 'Bloquear Generación por Cierre de Proceso', property: 'VerifyProcessClosure', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Usar Clase Visor', property: 'ViewerFactoryClass', visible: true },
        { title: 'Usar Versión', property: 'UserDocumentVersion', visible: true },
        { title: 'Versión', property: 'DocumentVersion', visible: true },
        { title: 'Fecha Versión', property: 'DocumentVersionDate', visible: true },
        { title: 'Desde', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "name": `Editar ${FactoryDocument.bean.Name}`, "view": true }) } },
            // { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <BasicPage titulo="Fabricas de Documentos">
            <div className="row">
                <div className="col-md-4">
                    <SelectProccessTypeConstants label='Tipo de Proceso' idSelector={processType} onChange={(e) => { setprocessType(e) }} />
                    seleccione un Tipo de Proceso*
                </div>
                <div className="col-md-4">
                    <BasicButton icon="ri-search-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable body={lista} head={head} rowSet={FactoryDocument.setBean} listButtons={listaBotones()}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                             <div className="col-md-6">
                                <label>Nombre</label>
                                <input type="text" name="Name" className="form-control" value={FactoryDocument.bean.Name} onChange={FactoryDocument.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label>Clase Visor</label>
                                <input type="text" name="ViewerFactoryClass" className="form-control" value={FactoryDocument.bean.ViewerFactoryClass} onChange={FactoryDocument.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <label></label>
                                <SelectProccessTypeConstants idSelector={FactoryDocument.bean.ProcessType} onChange={(e) => { FactoryDocument.setBean({ ...FactoryDocument.bean, "ProcessType": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={FactoryDocument.bean.UseViewerFactoryClass} label="Usar Clase Visor ?" eventChange={(e: any) => {
                                    FactoryDocument.setBean({ ...FactoryDocument.bean, "UseViewerFactoryClass": e })
                                }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={FactoryDocument.bean.UserDocumentVersion} label="Usar Versión ?" eventChange={(e: any) => {
                                    FactoryDocument.setBean({ ...FactoryDocument.bean, "UserDocumentVersion": e })
                                }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <BasicSwitch estado={FactoryDocument.bean.VerifyProcessClosure} label="Bloquear Generación por Cierre de Proceso ?" eventChange={(e: any) => {
                                    FactoryDocument.setBean({ ...FactoryDocument.bean, "VerifyProcessClosure": e })
                                }}></BasicSwitch>
                            </div>
                            <div className="col-md-6">
                                <label>Versión</label>
                                <input type="text" name="DocumentVersion" className="form-control" value={FactoryDocument.bean.DocumentVersion} onChange={FactoryDocument.handleChange} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="DocumentVersionDate" label="Fecha Versión" value={FactoryDocument.bean.DocumentVersionDate} setDate={(e: any) => { FactoryDocument.setBean({ ...FactoryDocument.bean, "DocumentVersionDate": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <input type="text" name="Description" className="form-control" value={FactoryDocument.bean.Description} onChange={FactoryDocument.handleChange} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {FactoryDocument.bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}